<template>

  <div>

    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Ввод данных клиента
        </div>
        <div
          class="body-info__block">
          <div
            class="info-user">
            <div
              class="info-user__line">
              <input
                type="text"
                v-model.trim="lastname"
                required
                id="lastname"
                class="inpt"
                :class="lastname ? 'active' : ''" />
              <label
                for="lastname"
                class="label">
                Фамилия
              </label>
              <span
                v-if="errors.lastname"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line">
              <input
                type="text"
                v-model.trim="firstname"
                required
                id="firstname"
                class="inpt"
                :class="firstname ? 'active' : ''" />
              <label
                for="firstname"
                class="label">
                Имя
              </label>
              <span
                v-if="errors.firstname"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line">
              <input
                type="text"
                v-model.trim="patronymic"
                required
                id="patronymic"
                class="inpt"
                :class="patronymic ? 'active' : ''" />
              <label
                for="patronymic"
                class="label">
                Отчество (при наличии)
              </label>
            </div>
            <div
              class="info-user__line">
              <masked-input
                class="inpt"
                v-model.trim="telefon"
                mask="\+\7 (111) 111-11-11"
                id="telefon"
                :class="telefon ? 'active' : ''" />
              <label
                for="telefon"
                class="label">
                Номер телефона
              </label>
              <span
                v-if="errors.telefon"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line half">
              <input
                type="text"
                v-model.trim="email"
                required
                id="email"
                class="inpt"
                :class="email ? 'active' : ''" />
              <label
                for="email"
                class="label">
                Адрес электронной почты (e-mail)
              </label>
            </div>
            <div
              class="info-user__line">
              <masked-input
                class="inpt"
                v-model.trim="passportserial"
                mask="№ 111111111 ИИН 111111111111"
                id="passportserial"
                :class="passportserial ? 'active' : ''" />
              <label
                for="passportserial"
                class="label">
                Номер удостоверения и ИИН
              </label>
              <span
                v-if="errors.passportserial"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line">
              <masked-input
                class="inpt"
                v-model.trim="passportdate"
                mask="11.11.1111"
                id="passportdate"
                :class="passportdate ? 'active' : ''" />
              <label
                for="passportdate"
                class="label">
                Дата выдачи удостоверения личности
              </label>
              <span
                v-if="errors.passportdate"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line">
              <masked-input
                class="inpt"
                v-model.trim="date"
                mask="11.11.1111"
                id="date"
                :class="date ? 'active' : ''" />
              <label
                for="date"
                class="label">
                Дата рождения
              </label>
              <span
                v-if="errors.date"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line full">
              <input
                type="text"
                v-model.trim="passportwho"
                required
                id="passportwho"
                class="inpt"
                :class="passportwho ? 'active' : ''" />
              <label
                for="passportwho"
                class="label">
                Кем выдано
              </label>
              <span
                v-if="errors.passportwho"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
            <div
              class="info-user__line full">
              <input
                type="text"
                v-model.trim="address"
                required
                id="address"
                class="inpt"
                :class="address ? 'active' : ''" />
              <label
                for="address"
                class="label">
                Адрес регистрации
              </label>
              <span
                v-if="errors.address"
                class="error-mess">
                Поле обязательно к заполнению
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="next()">
        Продолжить
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      lastname: '',
      firstname: '',
      patronymic: '',
      telefon: '',
      email: '',
      passportserial: '',
      passportdate: '',
      passportwho: '',
      date: '',
      address: '',
      errors: {
        lastname: false,
        firstname: false,
        telefon: false,
        passportserial: false,
        passportdate: false,
        passportwho: false,
        date: false,
        address: false,
      }
    }
  },
  computed: {
    ...mapState('buyphones', ['clientInfo']),
  },
  mounted() {
    if (this.clientInfo) {
      this.lastname = this.clientInfo.lastname;
      this.firstname = this.clientInfo.firstname;
      this.patronymic = this.clientInfo.patronymic;
      this.telefon = this.clientInfo.telefon;
      this.email = this.clientInfo.email;
      this.passportserial = this.clientInfo.passportserial;
      this.passportdate = this.clientInfo.passportdate;
      this.passportwho = this.clientInfo.passportwho;
      this.date = this.clientInfo.date;
      this.address = this.clientInfo.address;
    }
  },
  watch: {
    clientInfo(data) {
      if (data) {
        this.lastname = data.lastname;
        this.firstname = data.firstname;
        this.patronymic = data.patronymic;
        this.telefon = data.telefon;
        this.email = data.email;
        this.passportserial = data.passportserial;
        this.passportdate = data.passportdate;
        this.passportwho = data.passportwho;
        this.date = data.date;
        this.address = data.address;
      }
    },
    lastname() {
      this.errors.lastname = false;
    },
    firstname() {
      this.errors.firstname = false;
    },
    telefon() {
      this.errors.telefon = false;
    },
    passportserial() {
      this.errors.passportserial = false;
    },
    passportdate() {
      this.errors.passportdate = false;
    },
    passportwho() {
      this.errors.passportwho = false;
    },
    date() {
      this.errors.date = false;
    },
    address() {
      this.errors.address = false;
    },
  },
  methods: {
    ...mapMutations('buyphones', ['CHANGE_CLIENT_INFO', 'CHANGE_SCREEN_THREE']),

    next() {
      if (this.lastname == '') {
        this.errors.lastname = true;
        return false;
      }
      if (this.firstname == '') {
        this.errors.firstname = true;
        return false;
      }
      if (this.telefon == '') {
        this.errors.telefon = true;
        return false;
      }
      if (this.passportserial == '') {
        this.errors.passportserial = true;
        return false;
      }
      if (this.passportdate == '') {
        this.errors.passportdate = true;
        return false;
      }
      if (this.passportwho == '') {
        this.errors.passportwho = true;
        return false;
      }
      if (this.date == '') {
        this.errors.date = true;
        return false;
      }
      if (this.address == '') {
        this.errors.address = true;
        return false;
      }

      const user = {
        lastname: this.lastname,
        firstname: this.firstname,
        patronymic: this.patronymic,
        telefon: this.telefon,
        email: this.email,
        passportserial: this.passportserial,
        passportdate: this.passportdate,
        passportwho: this.passportwho,
        date: this.date,
        address: this.address,
      }

      this.CHANGE_CLIENT_INFO(user);
      this.CHANGE_SCREEN_THREE({ show2: false, show3: true });
    },
  }
}
</script>

<style lang="css">
</style>
